//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import wx from '@/common/wechat/sdk/jweixin-1.6.0'
import { isEnableOpenWeapp } from './../utils'
export default {
  name: 'JumpHaShop',
  data() {
    return {
      appletData: {
        id: 'gh_9c2320a2d832',
        path: 'pages/sub/store/store',
        name: '华安门店查询',
      },
    }
  },
  props: ['text', 'customClass'],
  created() {
    this.isEnableOpenWeapp = isEnableOpenWeapp
    wx.ready((res) => {
      console.log('res', res)
    })
    wx.error((err) => {
      console.log('error', err)
    })
  },
  computed: {
    isWx() {
      return isEnableOpenWeapp()
    }
  },
  methods: {
    // 跳转到华安门店h5
    toPage() {
      location.href = '/pages/sub/store/store'
    },
  }
}
